import { Component, Input, OnInit } from '@angular/core';
import findIndex from 'lodash-es/findIndex';
import cloneDeep from 'lodash-es/cloneDeep';
import isEmpty from 'lodash-es/isEmpty';

import { ViewportDetectionService } from '@finder/shared/services/viewport-detection/viewport-detection.service';
import { CommonModule } from '@angular/common';
import { DiningPlansTableComponent } from './table/table.component';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';

@Component({
    selector: 'finder-dining-plans',
    templateUrl: './dining-plans.component.html',
    styleUrls: ['./dining-plans.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        DiningPlansTableComponent,
        BreadcrumbComponent
    ],
})
export class DiningPlansComponent implements OnInit {

    @Input() data: any;
    isMobile: boolean;
    breadcrumb = [];

    constructor(private viewport: ViewportDetectionService) { }

    ngOnInit() {
        if (!this.data || isEmpty(this.data)) {
            return;
        }

        this.isMobile = this.viewport.isMobile();
        this.breadcrumb.push(this.data.labels.breadcrumb);
        this.viewport.onViewportResize().subscribe(() => {
            this.isMobile = this.viewport.isMobile();
        });
    }

    getDiningTableTitle(year: number) {
        return `${year} ${this.data.labels.tableTitle}`;
    }

    getPlansByYear(year: number) {
        // Deep clone to avoid changing original data and affecting other tables instances.
        const plans = cloneDeep(this.data.plans);

        // Filter plans entitlements with the given year.
        plans.forEach(plan => {
            plan.entitlements = plan.entitlements.filter(entitlementsByYear => {
                // indexValue will be -1 if it's not found
                const indexValue = findIndex(entitlementsByYear, ['year', year]);

                return indexValue <= 0;
            });
        });

        return plans;
    }
}
